import React from 'react';
import c from '../w.js';

const IconGrabber = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10H20V8H4V10ZM4 16H20V14H4V16Z"
      }
    )
  )
);

export { IconGrabber };
